<ng-template>
    <div class="flex items-stretch h-[60px]">
        <!-- Success icon -->
        <div class="flex items-center justify-center bg-app-global-tertiary w-[60px]" *ngIf="type === 'success'">
            <mat-icon svgIcon="square-check" class="text-white w-8 h-8"></mat-icon>
        </div>

        <!-- Error icon -->
        <div class="flex items-center justify-center bg-app-global-warning w-[60px]" *ngIf="type === 'warning'">
            <mat-icon svgIcon="square-x" class="text-white w-8 h-8"></mat-icon>
        </div>

        <!-- Content and clear button -->
        <div
            class="flex items-center justify-between p-5 text-xl gap-5 w-full overflow-hidden snackbar-content-container">
            <!-- Projected content -->
            <ng-content *ngIf="!message"></ng-content>

            <!-- Message content -->
            <p *ngIf="message">{{message}}</p>

            <!-- Clear button -->
            <button mat-icon-button [disableRipple]="true" class="text-app-global-text-primary mr-[-16px]"
                (click)="snackBarRef?.dismiss()" aria-label="Remove snackbar">
                <mat-icon svgIcon="x"></mat-icon>
            </button>
        </div>
    </div>
</ng-template>